

















































































































import { requiredRule } from "@/lib/rules/requiredRule";
import { LeasingDetails } from "@/models/leasing.entity";
import { PoliceDetails } from "@/models/police.entity";
import { IReferences } from "@/models/references.entity";
import { IReport } from "@/models/report.entity";
import {
  MrfiktivAttorneyDetailsGen,
  MrfiktivBrokerDetailsGen,
  MrfiktivCreateInsuranceDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import { DamageTypeEnum } from "@/store/enum/damage-type.enum";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class ReferencesForm extends Vue {
  DamageTypeEnum = DamageTypeEnum;
  CoverageTypeEnum = CoverageTypeEnum;

  @Prop()
  value!: IReferences;

  @Prop()
  report?: IReport;

  @Prop({ type: Boolean, default: true })
  showLeasing!: boolean;

  @Prop({ type: Boolean, default: true })
  showAttorney!: boolean;

  @Prop({ type: Boolean, default: true })
  showInsurance!: boolean;

  @Prop({ type: Boolean, default: true })
  showDamageBroker!: boolean;

  get requiredRule() {
    return [requiredRule()];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get policeDetails() {
    return this.value.policeDetails ?? new PoliceDetails({ department: "", fileReference: "" });
  }

  get leasing() {
    return this.value.leasing ?? new LeasingDetails({ company: "", claimNumber: "" });
  }

  get broker() {
    return this.value.broker ?? ({ name: "", number: "" } as MrfiktivBrokerDetailsGen);
  }

  get attorney() {
    return this.value.attorney ?? ({ name: "", number: "" } as MrfiktivAttorneyDetailsGen);
  }

  get insurance() {
    return this.value.insurance ?? ({ name: "", number: "" } as MrfiktivCreateInsuranceDtoGen);
  }
}
